module.exports = __webpack_public_path__ + "img/support_a100.9279328e.png";